import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


const BuyerDashboard = () => {

     const navigate = useNavigate()

     useEffect(() => navigate('/purchased'), [])

     return
}

export default BuyerDashboard;